export enum SubjectTypes {
  AllSubjects = 0,
  Wholesaler,
  ConsumerDirectMarket,
  Distributor,
  Carrier,
  GTS,
  FinalClient,
  Commercial = 8,
  Operator,
  RRM,
  Manager,
  ExtendedClient
}
